import { ArrowRight, Sparkles } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface AiPillProps {
  label?: string;
  onClick: () => void;
  className?: string;
}

/**
 * Inline "describe it instead" pill — surfaced on forms where the AI
 * composer is a faster path to the same outcome (e.g. manual invoice
 * creation). Matches mobile's AIPill: soft dividers, accent tint,
 * opens the composer without pre-filling the form.
 */
export function AiPill({
  label = 'Or just describe it',
  onClick,
  className,
}: AiPillProps) {
  return (
    <div className={cn('flex items-center gap-3', className)}>
      <div className="h-px flex-1 bg-line" aria-hidden />
      <button
        type="button"
        onClick={onClick}
        aria-label="Open AI assistant"
        className={cn(
          'inline-flex shrink-0 items-center gap-1.5 rounded-full border border-accent/35 bg-accent-soft/50',
          'px-3 py-1.5 text-xs font-medium text-accent transition-colors',
          'hover:border-accent/55 hover:bg-accent-soft/80',
        )}
      >
        <Sparkles className="size-3.5" strokeWidth={2.25} />
        <span>{label}</span>
        <ArrowRight className="size-3" strokeWidth={2.5} />
      </button>
      <div className="h-px flex-1 bg-line" aria-hidden />
    </div>
  );
}
